export default function ActionMenu({ index, onDelete, onEdit }) {
  return (
    <div
      className="absolute top-10 right-0 z-10 w-40 bg-white border border-gray-200 rounded-lg shadow-md"
      onMouseDown={(e) => e.stopPropagation()}
    >{onEdit && (
        <button
          className="flex items-center w-full gap-2 px-4 py-2 text-sm text-gray-900 hover:bg-gray-100"
          onClick={onEdit}
        >
          <svg
            className="w-5 h-5 text-gray-900"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      )}

      <button
        type="button"
        className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
        onClick={onDelete}
      >
        <svg
          className="w-5 h-5 text-red-600"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
          />
        </svg>
        Delete
      </button>
    </div>
  );
}
